export const APP_Z_INDEX = {
  stickyHeader: 200,
  columnResizer: 260,
  filterBar: 300,
  popoverBackdrop: 10040,
  dropdown: 10050,
  popover: 10060,
  dragOverlay: 11000,
  drawerBackdrop: 11480,
  drawer: 11490,
  modal: 11500,
  statusOverlay: 12000,
  headerDropdown: 12020,
} as const;
